import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import PersonCard from "../components/personCard";
import { Typography } from "antd";

const { Title } = Typography;

gsap.registerPlugin(ScrollTrigger);

const LeadershipComponent = () => {
  const sectionRef = useRef(null);
  const textRef = useRef(null);
  const cardRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate text block
      gsap.fromTo(
        textRef.current,
        { opacity: 0, y: 40 },
        {
          opacity: 1,
          y: 0,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: textRef.current,
            start: "top 80%",

            toggleActions: "play reverse play reverse",
          },
        }
      );

      // Animate PersonCard
      gsap.fromTo(
        cardRef.current,
        { opacity: 0, scale: 0.95 },
        {
          opacity: 1,
          scale: 1,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: cardRef.current,
            start: "top 80%",

            toggleActions: "play reverse play reverse",
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="bg-gradient-to-r from-customblue bg-blue-950 to-blue-300 text-white container px-6 lg:px-16 flex flex-col lg:flex-row items-center justify-between py-12"
    >
      <div
        ref={textRef}
        className="lg:w-2/3 flex flex-col items-center justify-center lg:text-left lg:mt-0 lg:mb-0 font-roboto"
      >
        <img
          src="../images/quata.png"
          alt="Quote"
          className="h-10 md:h-12 mb-6 mx-auto lg:mx-0"
        />
        <h2 className="text-3xl md:text-5xl font-bold mb-4">
          Leadership & Expertise
        </h2>

        <p className="leading-6 text-center text-sm md:text-lg">
          As CEO of Sun Pledge Holdings (Pvt) Ltd, I extend my heartfelt thanks
          for choosing us as your solar energy partner. We are driven by a deep
          commitment to sustainability and a vision for a greener tomorrow. Our
          goal is to deliver innovative solar solutions that not only meet your
          energy needs but also contribute to a cleaner planet. With expert
          teams and cutting-edge technology, we ensure excellence from
          consultation to installation and beyond.
        </p>

        <blockquote className="italic text-sm md:text-lg text-center mt-4">
          “Together, let’s harness the power of the sun to shape a brighter,
          more sustainable future.”
        </blockquote>

        <div className="mt-4 text-center">
          <Title className="!text-white !m-0" level={2}>
            Priyantha Jayasekara
          </Title>
          <Title className="!text-white !m-0 !italic" level={4}>
            Chief Executive Officer
          </Title>
          <Title className="!text-white !m-0 !italic" level={4}>
            Sun Pledge Holdings
          </Title>
        </div>
      </div>

      <div ref={cardRef} className="w-2/3 lg:w-1/3 justify-center mt-8 md:mt-0">
        <PersonCard
          image="../images/ceo.png"
          title="Priyantha Jayasekara"
          subtitle="CEO, Sun Pledge Holdings"
        />
      </div>
    </section>
  );
};

export default LeadershipComponent;
